<template>
  <v-select
    v-model="selected"
    label="Payment Type"
    :items="items"
    :loading="isLoading"
    outlined
    dense
    clearable
    item-text="name"
    item-value="id"
  />
</template>

<script>
export default {
  name: "AppPaymentTypesAutocomplete",
  data: () => ({
    isLoading: false,
    items: [],
    selected: null,
  }),
  watch: {
    selected: function () {
      this.$emit("input", this.selected);
    },
  },
  mounted() {
    this.loadPaymentTypes();
  },
  methods: {
    loadPaymentTypes: async function () {
      const self = this;
      self.isLoading = true;
      const { data } = await axios.get("/admin/setting/paymentTypes");
      self.items = data.data;
      self.isLoading = false;
    },
  },
};
</script>
